//
export default [
    {
        text: 'código interno',
        value: 'wh_internal_code',
    },
    {
        text: 'código proveedor',
        value: 'provider_product_code',
    },
    {
        text: 'nombre',
        value: 'wh_product_name',
    },
    {
        text: 'descripción',
        value: 'wh_description',
    },
    {
        text: 'estado',
        value: 'status',
    },
    {
        text: 'cantidad',
        value: 'wh_quantity',
    },
    {
        text: 'valor unitario',
        value: 'net_price',
        format: 'currency'
    },
    {
        text: 'subtotal',
        value: 'net_total',
        format: 'currency'
    },
    // {
    //     text: 'subtotal',
    //     align: 'center',
    //     format: 'currency',
    //     value: ({ net_total }) => net_total,
    // },
]
